// extracted by mini-css-extract-plugin
export var addButton = "_or-0";
export var border = "_or-8";
export var check = "_or-h";
export var danger = "_or-6";
export var dropdownContainer = "_or-1";
export var editModalBody = "_or-j";
export var footerContainer = "_or-i";
export var fullWidth = "_or-a";
export var hide = "_or-9";
export var icon = "_or-3";
export var input = "_or-7";
export var inputFlex = "_or-b";
export var inputWrapper = "_or-c";
export var manualFocus = "_or-5";
export var optionButton = "_or-4";
export var pillWrapper = "_or-e";
export var pointer = "_or-2";
export var showOverflow = "_or-f";
export var tagsFlex = "_or-d";
export var xButton = "_or-g";